import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { config } from '../config/environment'
import { stripLocalePrefix } from '../i18n/localeRouting'
import {
  initOneTagClickConversions,
  trackCallDMPageView,
  trackOneTagRoute,
} from '../utils/oneTag'

/**
 * SPA 라우터 변경마다 CallMtm · callDM 호출
 * @see https://enliple.notion.site/SPA-f03f16dbd0d14139ac71f3bfd7037c79
 * (1-2. 페이지 로드 후 / 라우터 변경 후 CallMtm())
 * @see https://enliple.notion.site/SPA-Single-Page-Application-SNS-1b9907ce77c78127a6a3d5deba68dc05
 * (3. 화면 전환 시 callDM())
 */
export function useOneTagPageView() {
  const location = useLocation()
  const enabled = config.oneTag.enabled

  useEffect(() => {
    if (!enabled) return
    initOneTagClickConversions()
  }, [enabled])

  useEffect(() => {
    if (!enabled) return
    const barePath = stripLocalePrefix(location.pathname)
    // 매핑 경로 → productCode CallMtm / 그 외 → bare CallMtm()
    trackOneTagRoute(barePath)
    // 데이터매니저: 화면 전환마다 callDM()
    trackCallDMPageView()
  }, [location.pathname, location.search, enabled])
}
